export const DERIVED_DEPARTURE_EXPLANATION =
  'Your district did not report these exits. A student who is on this year’s roster, met exit criteria at their most recent scored WIDA administration, and has no administration this year is counted as having exited. Exit counts, exit rates and median time to exit all include these students.';

export function derivedDepartureNote(count: number): string {
  return `${count} of this year’s exits were derived from testing and roster records`;
}

export const DATE_INFERRED_DEPARTURE_EXPLANATION =
  'Your roster gave these students an exit date but no exit reason. A student whose most recent ACCESS scores met your state’s exit criteria, or whose roster status reads as monitoring or reclassified, is counted as having met criteria. Students whose scores did not meet criteria, or who have no usable ACCESS score, are counted as having left for other reasons.';

export function dateInferredDepartureNote(count: number): string {
  return `${count} of this year’s exits were classified from ACCESS scores`;
}
